import React from "react";
import { useParams } from "react-router-dom";
import RootOutfitDetail from "container/outfitDetail/RootOutfitDetail";
import AppUpdateCheckpoint from "container/common/AppUpdateCheckpoint";

function OutfitDetailPage(props) {
  const params = useParams();

  return (
    <AppUpdateCheckpoint>
      <RootOutfitDetail outfitHash={params.outfitHash} />
    </AppUpdateCheckpoint>
  );
}

export default OutfitDetailPage;
